// import React from "react";
import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
// import "animate.css";

const NotifyMessageNoReload = (titleMsg, typeNotify) => {
  Store.addNotification({
    title: titleMsg,
    type: typeNotify,
    insert: "top",
    container: "top-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      showIcon: true,
      onScreen: true,
    },
  });
};

export default NotifyMessageNoReload;
